import Nav from "@components/common/Nav";
import ApiProxy from "./ApiProxy";
import Utility from "./sframe/Utility";

let setting =
{
  line:
  {
    channelId: "1660830406",
    secret: "c29721d1112e11a8a0a25e3a2bd8463c",
    token: ""
  }
};

let userInfo = 
{
  name: "",
  picture: "",
  rawData: {}
}




let LoginProxy =
{
  init()
  {
    if(Utility.urlParams.account_type && Utility.urlParams.token)
    {
      setting.line.token = Utility.urlParams.token;
      LoginProxy.getUserInfo();
    }
    // line login
    else if (Utility.urlParams.state = "login" && Utility.urlParams.code) {
      let code = Utility.urlParams.code;

      Utility.adjustUrlParams(["code", "state"]);

      // 取得權杖, 此動作與之後的步驟需改由後端處理後將 使用者基本資料 寫入網頁 page data 中
      let params =
      {
        grant_type: "authorization_code",
        code: code,
        redirect_uri: Utility.getPath(),
        client_id: setting.line.channelId,
        client_secret: setting.line.secret
      }
      $.ajax({
        method: "POST",
        dataType: 'json',
        url: "https://api.line.me/oauth2/v2.1/token",
        async: false,
        data: params,
        success: (data) =>
        {
          setting.line.token = data.id_token;
          console.log(setting.line.token);
          
          Utility.adjustUrlParams(null, {token: setting.line.token, account_type: "line"})
          LoginProxy.getUserInfo();
        }
      });
    }
  },

  getUserInfo()
  {
    $.ajax({
      method: "POST",
      dataType: 'json',
      url: "https://api.line.me/oauth2/v2.1/verify",
      async: false,
      data: {
        client_id: setting.line.channelId,
        id_token: setting.line.token
      },
      success: (data)=>
      {
      }
    }).then((result)=>
    {
      console.log(result);

      userInfo.name = result.name;
      userInfo.picture = result.picture;
      userInfo.rawData = result;

      Nav.setUserPicture(userInfo.picture);
      
    }).catch((result: JQueryXHR)=>
    {
      console.log(result.responseJSON);
      
      Utility.adjustUrlParams(["token", "account_type"]);
    });

  },

  loginByLine()
  {
    let redirect_uri = Utility.getPath(),
      link = `https://access.line.me/oauth2/v2.1/authorize?` +
        'response_type=code' +
        '&client_id=' + setting.line.channelId +
        '&redirect_uri=' + redirect_uri +
        '&state=login' +
        '&scope=openid%20profile%20email';

    // console.log(link);

    window.location.href = link;
  },

  loginBy(platform: "line" | "google" | "facebook")
  {
    window.location.href = ApiProxy.getCommonPageData().login_urls[platform];
  }
};

export default LoginProxy;